import { IDocuments } from "./process-api";

export interface IProcessFilter {
  orderBy: string;
  ascend: string;
  itemsByPage: number;
  pageIndex: number;
}

export interface IDocumentList {
  id: number;
  description: string;
}

export interface IEditProcess {
  id: number;
  description: string;
  documents?: IDocuments[];
  event?: number[];
}

export type IItems = {
  id: number;
  description: string;
  documents: IDocumentList[];
};

export type IProcessesList = {
  id: number;
  description: string;
};

export interface IProcessState {
  isLoading: boolean;
  isLoadingTable: boolean;
  disabledButton: boolean;
  visibleDrawerNewProcess: boolean;
  visibleDrawerEditProcess: boolean;
  editProcess: IEditProcess;
  items?: Array<IItems>;
  totalItems: number;
  filter: IProcessFilter;
  documentsList: Array<IDocumentList>;
  searchFilter: string;
  formEditModified: boolean;
  visibleDocuments: boolean;
  eventInboundActive: boolean;
  eventOutboundActive: boolean;
  allProcessesList: Array<IProcessesList>;
  allowImageCapture: boolean;
}

const documentsState = [
  {
    id: null,
    description: "",
  },
];

const processesState = [
  {
    id: null,
    description: "",
  },
];

export const defaultState: IProcessState = {
  isLoading: false,
  isLoadingTable: false,
  disabledButton: false,
  visibleDrawerNewProcess: false,
  visibleDrawerEditProcess: false,
  formEditModified: false,
  visibleDocuments: false,
  documentsList: documentsState,
  allProcessesList: processesState,
  eventInboundActive: false,
  eventOutboundActive: false,
  allowImageCapture: false,
  editProcess: null,
  items: [],
  totalItems: 0,
  searchFilter: "",
  filter: {
    orderBy: "",
    ascend: "",
    itemsByPage: 10,
    pageIndex: 1,
  },
};
